export default __webpack_public_path__ + "static/media/light-theme.a3420966.png";